import { render } from "./Formsan.vue?vue&type=template&id=1c1f648c"
import script from "./Formsan.vue?vue&type=script&lang=js"
export * from "./Formsan.vue?vue&type=script&lang=js"

import exportComponent from "D:\\fclinique\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__